import { useSelector } from 'react-redux';
import { useParams, useRouteMatch } from 'react-router-dom';
import { userSelector } from 'redux/selectors';
import { useGetOrganizationBySlugQuery } from 'services/organizations';

export const useClaimInfo = () => {
  const { networkSlug: slug, employerSlug: companySlug } = useParams();
  const { data, isLoading, isFetching, isError } = useGetOrganizationBySlugQuery({ slug, companySlug });
  const user = useSelector(userSelector);
  const network = data?.network?.collection;
  const isGetroForCompanies = network?.features?.includes?.('free_getro_for_companies') ?? false;

  const isUserSignedIn = Boolean(user?.id);
  const companyDomain = user?.email?.includes('@') ? user.email.split('@').pop() : null;
  const isEmailMatch = companyDomain === data?.company?.domain;

  const isMatch = useRouteMatch('/claim-your-profile/:networkSlug/company/:employerSlug/email_mismatch');
  const isOnboard = useRouteMatch('/claim-your-profile/:networkSlug/onboard');
  const userIsSignedUpWithCorrectEmailAndConfirmed = isUserSignedIn && isEmailMatch && user?.confirmed;
  const companyNetwork = user?.managingCollections?.find((o) => o.domain === data?.company?.domain);
  const companyNetworkIsFreeForCompanies = companyNetwork?.features?.includes?.('free_getro_for_companies');

  const redirectToOnboard = userIsSignedUpWithCorrectEmailAndConfirmed && companyNetworkIsFreeForCompanies;
  const redirectToHome = userIsSignedUpWithCorrectEmailAndConfirmed && !companyNetworkIsFreeForCompanies;
  const isOnboarding = !useRouteMatch('/claim-your-profile');
  const redirectToMismatch = !isMatch && isUserSignedIn && !isEmailMatch && data?.company && !isOnboarding;

  return {
    network,
    company: data?.company,
    user,
    isLoading: isLoading || isFetching,
    isError,
    isUserSignedIn,
    isEmailMatch,
    redirectToMismatch,
    redirectToOnboard,
    redirectToHome,
    userIsSignedUpWithCorrectEmailAndConfirmed,
    isGetroForCompanies,
    isOnboard,
    companyNetwork,
    isOnboarding,
  };
};
